
import { BaseAPI } from "../../BaseAPI";
import * as environment from '../../../config/environment';
class MenuSaveAPI extends BaseAPI {
  

  constructor () {
    const baseUrl = environment.API_URL + "MenuSave";
    super(baseUrl);
  }


  saveMenuSaveSave(request: MenuSaveRequest){
    
    return this.post("", request, false);
   
  }

}
export default new MenuSaveAPI();

class MenuSaveRequest {
    sqId?: number;
    parentId?: number;
    menuAdi: string;
    menuSirasi: number;
    ikonYolu: string;
    ikonYolu2:string;
    uyeTipi: number;
    sayfaLink?: string;
    guncellemeIzni: string;
    panel: number;
    kaydeden: string;
    kayitTarihi: Date;
    guncelleyen: string;
    guncellemeTarihi?: Date;
    yayinlanmaTarihi?: Date;
    yayinlanmaBitisTarihi?: Date;

    constructor(
        menuAdi: string,
        menuSirasi: number,
        ikonYolu: string,
        ikonYolu2:string,
        uyeTipi: number,
        
        guncellemeIzni: string,
        panel: number,
        kaydeden: string,
        kayitTarihi: Date,
        guncelleyen: string,
        sayfaLink?: string,
        sqId?: number,
        parentId?: number,
        guncellemeTarihi?: Date,
        yayinlanmaTarihi?: Date,
        yayinlanmaBitisTarihi?: Date
    ) {
        this.sqId = sqId;
        this.parentId = parentId;
        this.ikonYolu2=ikonYolu2;
        this.menuAdi = menuAdi;
        this.menuSirasi = menuSirasi;
        this.ikonYolu = ikonYolu;
        this.uyeTipi = uyeTipi;
        this.sayfaLink = sayfaLink;
        this.guncellemeIzni = guncellemeIzni;
        this.panel = panel;
        this.kaydeden = kaydeden;
        this.kayitTarihi = kayitTarihi;
        this.guncelleyen = guncelleyen;
        this.guncellemeTarihi = guncellemeTarihi;
        this.yayinlanmaTarihi = yayinlanmaTarihi;
        this.yayinlanmaBitisTarihi = yayinlanmaBitisTarihi;
    }
}
export { MenuSaveRequest };
